// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__aGQMS","label":"LabeledBox_label__2EZvI"};